import { Tabs, Tab, Tablist } from 'palette/Tabs';
import { burgerNavButtonGroupTracking } from '@common/BurgerNavigation/tracking';
import { menuSelectEntryTracking } from '@common/Tracking/Navigation';
import './styles/BurgerNavDepartments.scss';

function parseNavPathTopLevel(navigationPath) {
    const navTopLevel = navigationPath?.[0];
    const navId = navTopLevel?.split('_')[1];

    return parseInt(navId, 10);
}

function BurgerNavDepartments({
    menuItems,
    navigationPath,
    navItemClick,
    menuContainerRef,
    setSelectedDepartment
}) {
    function handleTabChange(event) {
        const navId = `id_${event}`;
        const navPath = [navId];
        const departmentItem = menuItems.find(item => item.navigationId === event);
        const departmentName = departmentItem?.languageContext.en?.name || departmentItem?.name;
        const selectedDepartment = { id: event, name: departmentName };

        burgerNavButtonGroupTracking(departmentName);
        setSelectedDepartment(selectedDepartment);
        menuSelectEntryTracking(departmentItem, selectedDepartment);
        navItemClick(navPath);
        menuContainerRef.current.scrollTop = 0;
    }

    return (
        <div className="burger-nav-departments">
            <Tabs
                overflow="wrap"
                theme="primary"
                value={parseNavPathTopLevel(navigationPath)}
                onChange={handleTabChange}
            >
                <Tablist>
                    {menuItems.map(({ children, label, navigationId }) => (
                        (children && children.length > 0) ? (
                            <Tab
                                key={navigationId}
                                id={navigationId}
                                label={label}
                            />
                        ) : null
                    ))}
                </Tablist>
            </Tabs>

        </div>
    );
}

export default BurgerNavDepartments;
